// Archives retain model reasoning for research; the transcript shows spoken text.
export function archiveText(text) {
  const raw = String(text || "");
  const close = raw.indexOf("</think>");
  const spoken = close >= 0 ? raw.slice(close + "</think>".length) : /^\s*<assessment[>\s]/i.test(raw) ? "" : raw;
  return spoken.replace(/<think>[\s\S]*?(?:<\/think>|$)/gi, "")
    .replace(/<\/end>\s*$/, "").trim();
}

// Older archives have no title. Label the deterministic excerpt instead of
// inventing a topic or using the course's newer memory / next-session plan.
export function sessionOverview(archive, row = {}) {
  const saved = archive?.summary;
  const summary = typeof saved === 'string' ? saved : saved?.session_summary_abstract || row.summary_abstract || '';
  const title = typeof saved?.session_topic === 'string' ? saved.session_topic.trim() : '';
  const sentence = summary.split(/(?<=[。！？.!?])\s*/u)[0];
  const excerpt = [...sentence].slice(0, 80).join('');
  return { topic: title || excerpt + (sentence.length > excerpt.length ? '…' : ''), summary, excerpt: !title && !!summary };
}

// Historical text is hydrated separately from live generation and playback.
export function createCourseHistoryReceiver(onMessage) {
  const messages = new Map();
  return {
    clear: () => messages.clear(),
    push(data) {
      if (!data || typeof data.id !== 'string' || !data.id ||
          !['user', 'assistant'].includes(data.role) || typeof data.delta !== 'string') return;
      const key = `${data.role}:${data.id}`;
      const text = (messages.get(key) || '') + data.delta;
      messages.set(key, text);
      onMessage?.({ id: `history:${data.id}`, role: data.role, text });
    },
  };
}
